import type {
  GetSessionByDeviceResponse,
  GetSessionsByTenantParams,
  GetSessionsByTenantResponse,
  OpenSessionByDeviceResponse,
  CloseSessionByDeviceResponse,
  OptInSessionByDeviceResponse
} from '#src/interfaces/CashRegisterSession'
import apiInstance from './cashRegisterApiClient'

const getSessionsByTenant = (tenantUuid: string, params?: GetSessionsByTenantParams) =>
  apiInstance<GetSessionsByTenantResponse>({
    method: 'GET',
    url: `/tenants/${tenantUuid}/sessions`,
    params
  })

const getSessionByDevice = (deviceUuid: string, sessionUuid: string) =>
  apiInstance<GetSessionByDeviceResponse>({
    method: 'GET',
    url: `/devices/${deviceUuid}/sessions/${sessionUuid}`
  })

const openSessionByDevice = (deviceUuid: string) =>
  apiInstance<OpenSessionByDeviceResponse>({
    method: 'POST',
    url: `/devices/${deviceUuid}/sessions`
  })

const closeSessionByDevice = (deviceUuid: string, sessionUuid: string) =>
  apiInstance<CloseSessionByDeviceResponse>({
    method: 'POST',
    url: `/devices/${deviceUuid}/sessions/${sessionUuid}/actions/close`
  })

const optInSessionByDevice = (deviceUuid: string, sessionUuid: string) =>
  apiInstance<OptInSessionByDeviceResponse>({
    method: 'POST',
    url: `/devices/${deviceUuid}/sessions/${sessionUuid}/actions/opt-in`
  })

export {
  getSessionsByTenant,
  getSessionByDevice,
  openSessionByDevice,
  closeSessionByDevice,
  optInSessionByDevice
}
